export default "__VITE_ASSET__86VG06Mr__"